import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Lenis from "lenis";
import "./About2.css";
import AboutA2Z from "./AboutA2Z";

gsap.registerPlugin(ScrollTrigger);

const AboutComponent2 = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Initialize Lenis for smooth scrolling
    const lenis = new Lenis({
      smooth: true,
      direction: "vertical",
      gestureDirection: "vertical",
      smoothTouch: true,
    });

    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add((time) => lenis.raf(time * 1000));
    gsap.ticker.lagSmoothing(0);
    lenis.start();

    const initialClipPaths = [
      "polygon(0% 0%, 0% 0%, 0% 0%, 0% 0%)",
      "polygon(33% 0%, 33% 0%, 33% 0%, 33% 0%)",
      "polygon(66% 0%, 66% 0%, 66% 0%, 66% 0%)",
      "polygon(0% 33%, 0% 33%, 0% 33%, 0% 33%)",
      "polygon(33% 33%, 33% 33%, 33% 33%, 33% 33%)",
      "polygon(66% 33%, 66% 33%, 66% 33%, 66% 33%)",
      "polygon(0% 66%, 0% 66%, 0% 66%, 0% 66%)",
      "polygon(33% 66%, 33% 66%, 33% 66%, 33% 66%)",
      "polygon(66% 66%, 66% 66%, 66% 66%, 66% 66%)",
    ];

    const finalClipPaths = [
      "polygon(0% 0%, 33.5% 0%, 33.5% 33%, 0% 33.5%)",
      "polygon(33% 0%, 66.5% 0%, 66.5% 33%, 33% 33.5%)",
      "polygon(66% 0%, 100% 0%, 100% 33%, 66% 33.5%)",
      "polygon(0% 33%, 33.5% 33%, 33.5% 66%, 0% 66.5%)",
      "polygon(33% 33%, 66.5% 33%, 66.5% 66%, 33% 66.5%)",
      "polygon(66% 33%, 100% 33%, 100% 66%, 66% 66.5%)",
      "polygon(0% 66%, 33.5% 66%, 33.5% 100%, 0% 100%)",
      "polygon(33% 66%, 66.5% 66%, 66.5% 100%, 33% 100%)",
      "polygon(66% 66%, 100% 66%, 100% 100%, 66% 100%)",
    ];

    function createMasks() {
      const imgs = containerRef.current.querySelectorAll(".img");
      imgs.forEach((img) => {
        img.innerHTML = ""; // Clear masks to avoid duplication
        for (let i = 1; i <= 9; i++) {
          const mask = document.createElement("div");
          mask.classList.add("mask", `m-${i}`);
          img.appendChild(mask);
        }
      });
    }

    createMasks();

    const rows = containerRef.current.querySelectorAll(".row");

    rows.forEach((row) => {
      const imgs = row.querySelectorAll(".img");
      imgs.forEach((img) => {
        const masks = img.querySelectorAll(".mask");
        masks.forEach((mask, index) => {
          gsap.set(mask, { clipPath: initialClipPaths[index] });
        });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: row,
            start: "top 75%",
            invalidateOnRefresh: true, // Reset on page re-enter
          },
        });

        const animationOrder = [
          [".m-1"],
          [".m-2", ".m-4"],
          [".m-3", ".m-5", ".m-7"],
          [".m-6", ".m-8"],
          [".m-9"],
        ];

        animationOrder.forEach((targets, index) => {
          tl.to(
            targets.map((cls) => img.querySelector(cls)),
            {
              clipPath: (i, el) =>
                finalClipPaths[Array.from(masks).indexOf(el)],
              duration: 0.5,
              ease: "power2.out",
              stagger: 0.1,
            },
            index * 0.125
          );
        });
      });
    });

    // Reset GSAP ScrollTriggers to ensure animations re-run
    ScrollTrigger.refresh();

    // Cleanup
    return () => {
      ScrollTrigger.killAll();
      gsap.ticker.remove((time) => lenis.raf(time));
      lenis.stop();
    };
  }, []);

  return (
    <div className="aboutContainer2" ref={containerRef}>
      <section className="Abouthero">
        <h1>ABOUT</h1>

        <img className="emnpicture"
          src="/Images/emn3.png"
          alt="EMN Logo"
          style={{
            width: "30%", // Image width fills the container
            height: "auto", // Auto height to maintain aspect ratio
            objectFit: "contain", // Contain the image within the box
            display: "block", // Block display to center
            marginTop: "-100px",
            position: "absolute",
          }}
        />
      </section>

      <section className="info"
        
      >
        <h2 className="emnH"
          style={{
            marginTop: "70px",
            position:"absolute",
        marginRight:"300px"
          }}
        >
          {" "}
          A Legacy of Experience, <br /> A Future of Fresh Ideas.
        </h2>

        <p className="emnP"
          style={{
            fontSize: "15px",
            position: "",
            width: "95%",

            marginTop: "140px",
            textAlign: "center",
          }}
        >
         E M N Trading Group, is an ambitious extension of Yemek Istanbul Catering Services, a leading company with over 40 years of experience in the catering industry. Building on Yemek Istanbul’s rich legacy of excellence and reliability, E M N Trading Group was created to diversify and expand into various sectors across the Middle East region.
         <br/>
         <br/>
Rooted in the values and expertise of its parent company, E M N Trading Group brings innovative solutions and a commitment to quality in every sector it ventures into. With its headquarters located in the United Arab Emirates. The group is strategically positioned to serve the dynamic needs of the Middle Eastern market, leveraging Yemek Istanbul’s deep understanding of regional and global business practices.
<br/>
<br/>
E M N Trading Group has expanded its expertise by incorporating A to Z Design Studio, offering innovative architectural solutions designed to meet the needs of the Middle East region. This partnership reflects our commitment to providing comprehensive services that address diverse client requirements while maintaining the highest standards of professionalism and success.
        </p>

        <p className="infoP" style={{

        }}>
          A to Z Design Studio
        </p>
      </section>

      <section className="hero-imgs">
        <div className="row">
          <div className="img img-1"></div>
          <div className="clients-list">
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <p className="clientsP">
              {" "}
              Founded by the father-daughter duo,
              <br />
              Abdullah and Zeyneb, A2Z reflects combining experience with fresh
              ideas to create designs that make a strong impact.
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              With years of experience and a passion for impactful design, we
              focus on creating spaces that combine practicality with artistic
              style.
            </p>
            <br />
            <br />
            <br />
            <br />
            <div
              className="showinglogo"
              style={{
                maxHeight: "400px",
              }}
            >
              <AboutA2Z />
            </div>
          </div>
        </div>
      </section>

      <section className="clients-imgs">
        <div className="row">
          <div className="img img-3"></div>
        </div>
      </section>

      <section className="clients">
        <div className="col">
          <p
            className="colp"
            style={{
              fontSize: "25px",
            }}
          >
            {" "}
            We take pride in our ability to deliver projects tailored to our
            clients' unique visions, from concept to completion.
            <br />
            <br />
            <br />{" "}
          </p>
        </div>
        <div className="col"></div>
      </section>

      <section className="products">
        <div className="row">
          <div className="img img-4"></div>
          <div className="">
            <h2 className="abouth2">
              <p
                style={{
                  fontSize: "70px",
                  textAlign: "right",
                }}
              >
                Designing Spaces with Purpose, Passion, and Precision.
              </p>
            </h2>
          </div>
        </div>
      </section>

      <section className="about">
        <p
          style={{
            textAlign: "right",
            fontStyle: "30px",
          }}
        ></p>
      </section>

      <section className="about-imgs">
        <div className="row">
          <div className="">
            <p
              className="aboutP2"
              style={{
                width: "40%",
                fontSize: "25px",
              }}
            >
              {" "}
              {/* Our portfolio spans residential, commercial, and bespoke ventures,
              embodying a fusion of modern innovation and classic
              sophistication. By integrating cutting-edge technology with
              exceptional craftsmanship, we ensure that every project not only
              meets but exceeds expectations. */}
              The portfolio covers residential, Commercial, and custom projects,
              blending modern innovation with classic elegance. By integrating
              advanced technology with expert craftsmanship, each project is
              crafted to deliver excellent results.
            </p>
          </div>
          <div className="img img-14"></div>
        </div>
      </section>

      <section className="hero-imgs" style={{ backgroundColor: "#242424" }}>
        <div
          className="aboutzeynebdiv"
          style={{
            position: "relative",
            display: "flex",
            width: "100%",
            height: "100vh", // Full viewport height for visibility
          }}
        >
          {/* Left section: Text */}
          <div
            style={{
              flex: 1, // 50% of the width
              padding: "20px",
              overflowY: "auto",

              width: "100%",
            }}
          >
            <p
              className="aboutZeyneb"
              style={{
                fontSize: "20px",
                textAlign: "center",
                margin: "0 50px",
                color: "#E0ECEE",
              }}
            >
              <br />
              <br />
              <br />
              I GRADUATED WITH HONORS FROM BILKENT UNIVERSITY’S FACULTY OF FINE
              ARTS, SPECIALIZING IN INTERIOR ARCHITECTURE AND ENVIRONMENTAL
              DESIGN. ALSO, I HAVE COMPLETED MY MASTER OF BUSINESS
              ADMINISTRATION (MBA) AT THE UNIVERSITY OF GLOUCESTERSHIRE. SINCE
              THEN, I HAVE HAD THE OPPORTUNITY TO WORK ON VARIOUS PROJECTS IN
              DIFFERENT COUNTRIES.
              <br />
              <br />
              I BELIEVE IN A DESIGN APPROACH WHERE EVERY PROJECT HAS UNIQUE
              REQUIREMENTS, AND EVERY CLIENT HAS THEIR OWN DISTINCT STYLE. A
              DESIGNER'S RESPONSIBILITY IS TO THOROUGHLY UNDERSTAND THESE
              REQUIREMENTS AND STYLES, THEN DELIVER AN OUTCOME THAT ALIGNS WITH
              THEIR ACADEMIC TRAINING AND PROFESSIONAL EXPERIENCE. BY
              PROFESSIONALLY INVOLVING ALL STAKEHOLDERS IN THE PROCESS AND
              ESTABLISHING A CLOSE CONNECTION WITH THE LIFESTYLE OF THE END
              USER, A SUCCESSFUL RESULT CAN BE ACHIEVED.
              <br />
              <br />
              <br />
              <h2
                style={{
                  fontFamily: "robertortiz",
                  textTransform: "none",
                  fontSize: "60px",
                  letterSpacing: "5px", // Adds space between letters, making the text longer
                  fontWeight: "100",
                }}
              >
                Zeyneb Cortu
              </h2>
            </p>
          </div>

          {/* Right section: Image */}
          <div
            style={{
              flex: 1, // 50% of the width
              backgroundImage: "url('../Images/landingpageimage/zeyneb.jpg')", // Replace with your image URL
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          ></div>

          {/* Centered text: Zeyneb Cortu */}
          {/* <div
            style={{
              position: "absolute",
              top: "20%",
              left: "45%",
              transform: "translate(-50%, -50%)",
              fontSize: "50px",
              fontFamily: "'kugile', cursive, sans-serif",
              color: "rgba(0, 0, 0, 0.8)", // Semi-transparent black
              textAlign: "center",
              zIndex: 2,
              pointerEvents: "none", // Ensure it doesn't block interactions with other elements
            }}
          >
            Zeyneb Cortu
          </div> */}
        </div>
      </section>

      <section className="outro">
        <div className="row">
          <div className="img img-15"></div>
          <div className="img img-16"></div>
          <div className="img img-17"></div>
        </div>
      </section>
    </div>
  );
};

export default AboutComponent2;
